import { Typography } from "@mui/material";

export default function ComponentTitle(props: {title: string}) {
	return <div className="titlebar" style={{marginBottom: "1rem", display: "inline-block", verticalAlign: "sub"}}>
	  <Typography variant="h5" fontWeight={"bold"}>
		{props.title}
	  </Typography>
	</div>
}